module.exports = __webpack_public_path__ + "static/gatsby-4cccd32fe1f7a2f6ce243a78e161bf22.png";